import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, revealOnce } from '@/lib/motion';

export default function SeoContent() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-testid="seo-content">
      <div className="max-w-5xl mx-auto">
        <motion.div {...revealOnce} variants={fadeUp} className="prose prose-earth max-w-none">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-earth-dark tracking-tight text-center mb-8">
            Spice Powders for Importers, Packers and Food Manufacturers
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm text-earth/70 font-sans leading-relaxed">
            <div>
              <h3 className="font-display text-lg font-bold text-earth-dark mb-3">What we supply</h3>
              <p>
                We export six spice powders: turmeric with 3–5% curcumin, red chilli from Guntur, Teja and Byadgi chillies (15,000–50,000 SHU), coriander, garlic with at least 0.3% allicin, cumin with 2.5–4% volatile oil, and Malabar or Tellicherry black pepper with 4–7% piperine.
              </p>
              <p className="mt-3">
                Each powder is ground from machine-cleaned, farm-sourced spice and checked for moisture, colour and purity before packing. Our FSSAI licence, APEDA registration and IEC are listed on our About page, and shelf life runs from 12 to 24 months depending on the product.
              </p>
            </div>
            <div>
              <h3 className="font-display text-lg font-bold text-earth-dark mb-3">Orders, documents and shipping</h3>
              <p>
                Orders start at 1 MT per powder (2 MT for garlic powder), packed in 25 kg PP bags, 50 kg jute bags, 25 kg cartons or your own private-label packaging. Every lot ships with a lab analysis report, and we prepare the phytosanitary certificate, certificate of origin, fumigation and health certificates your customs broker needs.
              </p>
              <p className="mt-3">
                We quote FOB, CIF or CNF and ship FCL or LCL from JNPT (Nhava Sheva) or Mundra. The production and dispatch schedule is confirmed in writing with every quote, so you can plan your arrivals with confidence.
              </p>
            </div>
          </div>
          <div className="mt-8 text-center">
            <p className="text-sm text-earth/50 font-sans">
              Our export office is in Chhatrapati Sambhajinagar, Maharashtra, and we supply buyers in the UAE, UK, Europe and Asia. Send the product, quantity and destination port, and our team will reply with a quote within 24 hours.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
